import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import css from './ModalHeader.css';

const ModalHeader = props => {
  return (
    <header className={css['header']}>
      <h1>
        {props.isEdit ? "Edit" : "Add"} Category
      </h1>
      <StyledButton 
        className={css['close-button']} 
        onClick={props.closeModal}
        aria-label="Close deep link modal"
        asLink>
        <Icon icon='close' />
      </StyledButton>
    </header>
  );
};

ModalHeader.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
};


export default ModalHeader;
